import { useEffect } from "react";
import { collectionsKeysT, tabsCollectionT } from "../../redux/features/ui/ui.types";
import { setActiveCategory, setActiveSubcategory, setActiveTab } from "../../redux/features/ui/uiSlice";
import { getPointsShow } from "../../redux/selectors/points.selector";
import {
  getActiveCategory,
  getActiveCollectionObj,
  getActiveTab,
  getCollectionCategoryes,
  getCollectionTabs,
  getIsPillowAvailable,
} from "../../redux/selectors/ui.selector";
import { store } from "../../redux/store";
import { useAppDispatch, useAppSelector } from "../../utils/hooks";
import { isSectionalConfigurator } from "../../utils/supportUtils";
import { setModelVisibility } from "../../utils/threekit/threekitFunc";

import { capitalize } from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import { THREEKIT_PARAMS } from "../../utils/constants";
import { init3kit } from "../../utils/init3kit";
import { CustomizedState } from "../Player/Player";
import s from "./TabsConfigurationInterface.module.scss";

export const TabsConfigurationInterface = (props: any) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { pathname, search } = useLocation();
  const locationState = useLocation().state as CustomizedState;
  const collectionId = !!locationState
    ? (locationState.collectionId as collectionsKeysT)
    : (pathname.split("/")[1] as collectionsKeysT);
  const activeCollectionObj = useAppSelector((state) => getActiveCollectionObj(state)(collectionId));

  // Мемоизация результатов выполнения селекторов
  const objTabs = useAppSelector(getCollectionTabs);
  const activeTab = useAppSelector(getActiveTab);
  const activeCategory = useAppSelector(getActiveCategory);
  const objCategoryes: any = useAppSelector(getCollectionCategoryes);
  const isPillowsAvailable = useAppSelector(getIsPillowAvailable);

  useEffect(() => {
    const interval = setInterval(async () => {
      const state = store.getState();
      const objTabs: any = state.ui.configUI.componentsUI.objTabs;
      const keysObjTabs = Object.keys(objTabs);
      if (objTabs) {
        const tab = keysObjTabs[0];
        const category = objTabs[keysObjTabs[0]][0];
        clearInterval(interval);
        dispatch(setActiveTab(tab));
        dispatch(setActiveCategory(category));
      }
    }, 100);
  }, []);

  useEffect(() => {
    const state = store.getState();
    let pointsShow = getPointsShow(state);
    if (activeCategory && isSectionalConfigurator() && activeCategory === "accordionAdditionalSections") {
      pointsShow["showPoint"].forEach((point) => {
        if (point) {
          setModelVisibility(point, true);
        }
      });
      pointsShow["listNotVisible"].forEach((point) => {
        if (point) {
          setModelVisibility(point, true);
        }
      });
    } else if (activeCategory && isSectionalConfigurator()) {
      pointsShow["showPoint"].forEach((point) => {
        if (point) {
          setModelVisibility(point, false);
        }
      });
      pointsShow["listNotVisible"].forEach((point) => {
        if (point) {
          setModelVisibility(point, false);
        }
      });
    }
  }, [activeCategory]);

  return (
    <div className={s.interface_tab__block}>
      {objTabs.length > 0 &&
        objTabs.map((objTabKey: tabsCollectionT, index: number) => {
          const isActive = objTabKey === activeTab ? s.active : "";
          return (
            <div
              className={`${s.interface_tab} ${isActive} ${objTabs.length === 1 && s.interface_oneTab} interface_tab`}
              data-activetab={objTabKey === activeTab}
              style={
                (activeTab === "Headboards Only" || activeTab === "Beds") && !isActive
                  ? { color: "#E9E7DB", borderColor: "#E9E7DB" }
                  : {}
              }
              onClick={() => {
                //@ts-ignore
                if (objTabKey === "pillows" && !isPillowsAvailable) {
                  return;
                }
                //@ts-ignore
                if (objTabKey === "pillows") {
                  dispatch(setActiveSubcategory(capitalize(objTabKey)));
                } else {
                  dispatch(setActiveSubcategory(capitalize(collectionId)));
                }

                dispatch(setActiveTab(objTabKey));
                dispatch(setActiveCategory(objCategoryes[objTabKey][0]));
                if (activeTab === "Headboards Only" || activeTab === "Beds") {
                  const assetId =
                    activeTab === "Beds" ? activeCollectionObj["aseetId"][1] : activeCollectionObj["aseetId"][0];
                  const player = document.getElementById("player");
                  init3kit({
                    playerEl: player,
                    idConfig: null,
                    THREEKIT_PARAMS: {
                      ...THREEKIT_PARAMS,
                      assetId,
                    },
                    dispatch,
                    collection: collectionId,
                    configuratorName: activeCollectionObj["id"],
                    startModel: "Eastern King",
                  });
                }
              }}
              key={`${objTabKey}-${index}`}
            >
              {objTabKey}
            </div>
          );
        })}
    </div>
  );
};
